import React from "react";

interface PageWrapperProps {
  children: React.ReactNode;
  withBackground?: boolean;
  padding?: 'none' | 'small' | 'default' | 'large';
}

/**
 * PageWrapper - Standardized layout wrapper for all pages
 *
 * Provides consistent:
 * - Flex layout structure
 * - Overflow handling
 * - Background colors
 * - Padding
 */
export const PageWrapper: React.FC<PageWrapperProps> = ({
  children,
  withBackground = false,
  padding = 'default'
}) => {
  const bgClass = withBackground ? 'bg-[#F5F5F5]' : '';

  const paddingClass = {
    none: '',
    small: 'p-2',
    default: 'p-4',
    large: 'p-6'
  }[padding];

  return (
    <div className="flex flex-col h-full">
      <main className={`flex-1 overflow-y-auto ${bgClass}`}>
        <div className={`w-full ${paddingClass}`}>
          {children}
        </div>
      </main>
    </div>
  );
};
